<template>
  <!-- <q-layout class="bg-black"> -->
  <div
    class="domain-control column q-dark:bg-dark q-light:bg-white"
    style="height: 100vh; width: 100vm; position: relative"
  >
    <q-btn
      class="absolute"
      size="20px"
      style="bottom: 2px; left: 15px; z-index: 999"
      flat
      round
      icon="settings"
      @click="openBluetoothConnect = true"
    />
    <!-- <q-icon
      v-if="showFullscreenIcon"
      class="absolute"
      style="top: 5px; right: 13px; z-index: 1"
      @click="$q.fullscreen.toggle()"
      :name="$q.fullscreen.isActive ? 'fullscreen_exit' : 'fullscreen'"
      size="40px"
    /> -->
    <!-- <q-img
        style="top: 30px; right: -333px; z-index: 1; width: 40px;display: inline;"
        :src="logo"
      /> -->
    <!-- <div
      class="absolute column items-center"
      style="
        right: 110px;
        top: 5px;
        width: 60px;
        height: 50px;
        z-index: 1;
        padding: 12px;
      "
    >
      <q-img :src="logo" alt="logo" style="margin-top: 7px" />
      <span style="width: 80px; margin-left: 20px; font-size: 18px"
        >智能底盘</span
      >
    </div> -->
    <!-- (!domainControlStore.isConnected ||
          !domainControlStore.isAndroidMainUser) &&
        !isDev -->

    <template
      v-if="
        (!domainControlStore.isConnected ||
          !domainControlStore.isAndroidMainUser) &&
        !isDev
      "
    >
      <div
        class="column justify-center items-center content-center text-secondary q-gutter-md"
        style="flex: 1"
      >
        <template v-if="!isSupportBluetooth">
          <q-icon name="mobile_off" color="teal" size="4.4em" />
          <span class="text-h6">当前设备不支持蓝牙 </span>
        </template>
        <template v-else>
          <template v-if="domainControlStore.isAndroidMainUser">
            <span class="absolute-center text-h4" style="top: 10%">
              {{ route.name === "ESP32Update" ? "OTA更新" : "域控UI" }}
            </span>
            <q-icon name="bluetooth_disabled" color="teal" size="4.4em" />
            <span class="text-h6">蓝牙未连接 </span>
            <span class="text-weight-bold">
              <q-btn
                outline
                rounded
                size="lg"
                :loading="!!loading[0]"
                @click="connectToDevice"
                style="min-width: 200px"
              >
                {{ domainControlStore.isConnected ? "已连接" : "链接蓝牙" }}
                <template v-slot:loading>
                  <q-spinner-hourglass class="on-left" />
                  连接中...
                </template>
              </q-btn>
            </span>
            <div
              class="click-count absolute"
              @click="handleClick"
              style="width: 25vw; height: 25vh; left: 0; bottom: 0"
            ></div>
          </template>
          <template v-else>
            <q-icon name="bluetooth_disabled" color="teal" size="4.4em" />
            <span class="text-h6">仅主用户可使用</span>
          </template>
        </template>
      </div>
    </template>
    <template v-else>
      <div class="column" style="flex: 1">
        <div style="height: 100%; flex: 1" class="col-auto">
          <router-view v-if="showView"></router-view>
        </div>
        <q-tabs v-show="route.name !== 'ESP32Update'" dense>
          <!--  :icon="tabItem.icon" -->
          <q-route-tab
            style="height: 50px; width: 100px; border-radius: 5px"
            content-class="h5"
            v-for="(tabItem, index) in menuList"
            key="index"
            :name="tabItem.name"
            :to="tabItem.value"
            :label="tabItem.name"
            exact
          />
          <!-- 全屏 -->
          <q-icon
            v-if="showFullscreenIcon && isWeb"
            class="fixed"
            style="right: 25px"
            :style="{
              bottom: $q.fullscreen.isActive ? '18px' : 'unset',
              top: !$q.fullscreen.isActive ? '20px' : 'unset',
            }"
            @click="$q.fullscreen.toggle()"
            :name="$q.fullscreen.isActive ? 'fullscreen_exit' : 'fullscreen'"
            size="35px"
          />
        </q-tabs>
      </div>
    </template>
    <BluetoothContorller v-model="openBluetoothConnect" />
  </div>
  <!-- </q-page>
    </q-page-container> -->
  <!-- </q-layout> -->
</template>

<script setup lang="ts">
import { isSupportBluetooth } from "@/utils/bluetooth";
import { ref, onMounted, onUnmounted, computed, watch } from "vue";
// import ICC from "./ICC.vue";
import { useQuasar } from "quasar";
import { menuList } from "./helper";
// import { ESP32BLEBluetooth } from "@/services/domainControl";
// import { BleDevice } from "@capacitor-community/bluetooth-le";
import { useDomainControlStore } from "@/stores/domainControl";
import BluetoothContorller from "./components/BluetoothContorller.vue";
import { onBeforeRouteUpdate, useRoute, useRouter } from "vue-router";
// import logo from "@/assets/img/lixiang_logo.png";
import { isDev } from "@/utils/env";
import { isWeb, platform } from "@/utils/capacitor";
import UserId from "@/utils/capacitor/useridPlugin";
import VConsole from "vconsole";

// route
const route = useRoute();
const router = useRouter();
const showFullscreenIcon = computed(() => {
  // return !["DUR", "DMC"].includes(route.name as any); // 根据需要调整路由名称
  return true;
});
// auasar
const $q = useQuasar();

const domainControlStore = useDomainControlStore();

// bluetooth
const openBluetoothConnect = ref(false);
const loading = ref([] as boolean[]);
const showView = ref(true);
// 添加点击计数和时间戳相关变量
const clickCount = ref(0);
const lastClickTime = ref(0);
const CLICK_TIMEOUT = 1000; // 3秒内需要完成5次点击

const vConsole = ref<VConsole | null>(null);

// set isAndroidMainUser
if (platform === "android") {
  UserId.getUserId().then((res) => {
    const userId = res.userId;
    if (userId !== 0) {
      domainControlStore.changeIsAndroidMainUser(false);
    }
  });
}

// const domainControlStore.isConnected = ref(false);
//  tab
// const tab = ref("ICC");
const handleDisconnected = async () => {
  domainControlStore.changeIsConnectedStatus(false);
  $q.notify("蓝牙已断开连接");
  loading.value[0] = false;
  // router.push({ name: "Home" });
};
// 链接蓝牙
const connectToDevice = async () => {
  domainControlStore.connectToDevice(
    handleDisconnected,
    loading,
    route.name?.toString()
  );
};
// 链接蓝牙
const autoConnectToDevice = async () => {
  if (isWeb) return;
  connectToDevice();
};

const handleBeforeunload = (event: any) => {
  domainControlStore.disconnectDevice();
};
// theme
function applyTheme(theme: string) {
  $q.dark.set(theme === "dark");
}

const handleThemeChange = (e: any) => {
  applyTheme(e.matches ? "dark" : "light");
};

const watchThemeChange = () => {
  // 监听系统主题
  const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
  applyTheme(mediaQuery.matches ? "dark" : "light");
  mediaQuery.addEventListener("change", handleThemeChange);
};
// screen size
const handleSetScreenSize = () => {
  if (isWeb) return;
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  let width = screenWidth < 1900 ? 1291 : 1400; // 按比例缩放
  let height = 807; // 按比例缩放

  const viewport = document.querySelector('meta[name="viewport"]');

  console.log("[LOG] screenWidth:", screenWidth);
  console.log("[LOG] screenHeight:", screenHeight);
  // 根据屏幕宽度计算缩放比例
  const scale =
    screenWidth < 1900
      ? Math.min(screenWidth / width)
      : Math.min(screenWidth / width, screenHeight / height);
  console.log("[BOWEN_LOG] 🚀 ~~ onMounted ~~ scale:", scale);
  viewport?.setAttribute(
    "content",
    "width=device-width, initial-scale=" + scale
  );
};
// 判断连续点击屏幕 5 下
const handleClick = () => {
  const currentTime = Date.now();
  if (currentTime - lastClickTime.value > CLICK_TIMEOUT) {
    // 如果距离上次点击超过3秒，重置计数
    clickCount.value = 1;
  } else {
    clickCount.value++;
  }
  lastClickTime.value = currentTime;
  if (clickCount.value === 5) {
    console.log("检测到连续5次点击!");
    // 在这里添加你想要触发的操作
    if (route.name !== "ESP32Update") {
      router.push({ name: "ESP32Update" });
    } else {
      router.push({ name: "Home" });
    }
    clickCount.value = 0; // 重置计数
  }
};

const setupVConsole = () => {
  vConsole.value = new VConsole();
};

onMounted(() => {
  domainControlStore.pageMounted(handleDisconnected); // hot-update
  window.addEventListener("beforeunload", handleBeforeunload);
  handleSetScreenSize();
  watchThemeChange();
  setTimeout(() => {
    autoConnectToDevice();
  }, 1000);
});
onUnmounted(() => {
  domainControlStore.disconnectDevice();
  window.removeEventListener("beforeunload", handleBeforeunload);
  vConsole.value?.destroy();
});

// 与 beforeRouteUpdate 相同，无法访问 `this`
// onBeforeRouteUpdate(async (to, from) => {
//   console.log("[BOWEN_LOG] 🚀 ~~ onBeforeRouteUpdate ~~ to, from:", to, from);
//   //仅当 id 更改时才获取用户，例如仅 query 或 hash 值已更改
// });

const handleResetView = () => {
  showView.value = false;
  setTimeout(() => {
    showView.value = true;
  }, 100);
};

watch(
  () => $q.dark.isActive,
  (val) => {
    console.log(val ? "On dark mode" : "On light mode");
    document.body.classList.toggle("dark", val);
    handleResetView();
  }
);

watch(
  () => domainControlStore.showVConsole,
  (val) => {
    if (val) {
      if (vConsole.value) {
        vConsole.value.showSwitch();
      } else {
        setupVConsole();
      }
    } else {
      vConsole.value?.hideSwitch();
    }
  },
  {
    immediate: true,
  }
);
</script>

<style lang="scss">
.q-chip {
  border-radius: 8px !important;
}
.select-chip {
  background-color: rgba(129, 138, 146, 0.4);
  color: #fff;
  // padding: 0 10px;
}
.select-chip.q-chip.disabled {
  opacity: 0.6 !important;
}
.select-chip.q-chip--selected {
  background-color: #4caf50;
}

// 并且不是 q-btn--round
.q-btn:not(.q-btn--round) {
  border-radius: 8px !important;
}

/* 禁用长按菜单 */
* {
  -webkit-touch-callout: none; /* 禁用Safari上的长按菜单 */
  -webkit-user-select: none; /* 禁用Safari上的文本选择 */
  -moz-user-select: none; /* 禁用Firefox上的文本选择 */
  -ms-user-select: none; /* 禁用IE上的文本选择 */
  user-select: none; /* 禁用其他浏览器上的文本选择 */
}

#__vconsole {
  font-size: 14px !important;
}

::-webkit-scrollbar {
  height: 12px;
  width: 14px;
  background: transparent;
  z-index: 12;
  overflow: visible;
}

::-webkit-scrollbar-thumb {
  width: 10px;
  background-color: #00b4ff;
  border-radius: 10px;
  z-index: 12;
  border: 4px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  -webkit-transition: background-color 0.28s ease-in-out;
  transition: background-color 0.28s ease-in-out;
  margin: 4px;
  min-height: 32px;
  min-width: 32px;
}

::-webkit-scrollbar-thumb:hover {
  background: #00b4ff;
}

.btn-style {
  background: radial-gradient(
    circle at center,
    rgba(252, 251, 251, 0.8) 0%,
    /* 中心发光 */ rgb(176, 183, 193) 70%,
    /* 渐变过渡 */ rgb(156, 158, 161) 100% /* 边缘颜色 */
  ) !important;
}
.btn-active {
  background: radial-gradient(
    circle at center,
    rgba(247, 194, 145, 0.8) 0%,
    /* 中心发光 */ rgb(215, 153, 82) 40%,
    /* 渐变过渡 */ rgb(224, 101, 1) 100% /* 边缘颜色 */
  ) !important;
}

.chart-tip {
  font-weight: 700;
  font-size: 18px;
  padding: 5px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
}
.domain-control {
  // background-color: #d1d9e2 ;
  // border-radius: 20px !important;
  // overflow: hidden;
  height: 100vh; /* 确保高度覆盖整个视口 */
  width: 100vw; /* 确保宽度覆盖整个视口 */
  overflow: hidden; /* 防止溢出 */
}
.domain-control .q-card {
  border-radius: 20px;
  // box-shadow: 0 1px 13px 7px rgba(0, 0, 0, 0.2);
  // background: radial-gradient(
  //   circle,
  //   rgb(250 253 255) 0%,
  //   rgb(162 171 182) 100%
  // );
  border: 0;
  // background: #ffffff;
  box-shadow: none;
}
// .gradient-text {
//   background: linear-gradient(to right, rgb(78 104 121), rgb(247 112 0));
//   -webkit-background-clip: text; /*将设置的背景颜色限制在文字中*/
//   -webkit-text-fill-color: transparent; /*给文字设置成透明*/
// }

// body {
//   background-color: transparent !important;
// }

.body--light {
  .q-tabs {
    background-color: #d1d9e2 !important;
  }
  .q-tab {
    background-color: #d1d9e2 !important;
  }
  .q-tab--active {
    background-color: #fff !important;
  }
  .domain-control {
    background-color: #fff !important;
  }
  .q-card {
    background-color: #d1d9e2 !important;
  }
  .q-img__content > div {
    color: #000;
  }
  .slider-color {
    color: #032f2b;
  }
}
.body--dark {
  .q-tabs {
    background-color: #292d32 !important;
  }
  .q-tab {
    background-color: #292d32 !important;
  }
  .q-tab--active {
    background-color: #000 !important;
  }
  .domain-control {
    background-color: #000;
  }
  .q-card {
    background-color: #292d32 !important;
  }
  .q-img__content > div {
    color: #ffffff;
  }
  .slider-color {
    color: #ffffff;
  }
}
</style>
<style scoped lang="scss">
.q-tabs {
  // background-color: #fff !important;
  text-transform: none;
  border-radius: 20px !important;
  margin: 0 16px;
  // margin-bottom: 10px;
  padding: 5px;
}
.q-tab {
  // background-color: #fff !important;
  text-transform: none;
  border-radius: 10px !important;
  /* margin: 0 20px; */
}
// .q-tab--active {
//   /* background: radial-gradient(circle, #e6ebef, #8e96a1) !important; */
//   background-color: #d1d9e2  !important;
// }
:deep(.q-tab__indicator) {
  display: none;
}
:deep(.q-tab__label) {
  font-size: 18px;
  font-weight: 700;
}

// :deep(.q-img__content > div) {
//   color: #000;
// }
/* .q-layout-container { */

/* } */

:deep(.q-linear-progress__stripe) {
  animation: progress-linear-stripes 10s infinite linear;
}

@keyframes progress-linear-stripes {
  0% {
    background-position-x: 1000px;
  }
}
</style>
